import { isImage, isVideo, isDocument } from 'utilities/file';

import FiltersInterface from './filters';

class DataCollections {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/data-collections`;
    this.apiClient = apiClient;

    this.filters = new FiltersInterface(`${this.basePath}/:collectionId`, apiClient);

  }

  async bootstrap(query, urlParameters) {

    const path = `${this.basePath}/bootstrap`;

    return this.apiClient.post(path, {}, {}, { query, urlParameters });

  }

  async setupCollection(data) {

    const path = `${this.basePath}`;

    return this.apiClient.post(path, {}, {}, data);

  }

  async setupCollectionFromFile(data) {

    const path = `${this.basePath}/from-file`;

    return this.apiClient.post(path, {}, {}, data);

  }

  async updateCollection(collectionId, data) {

    const path = `${this.basePath}/:collectionId`;

    return this.apiClient.put(path, { collectionId }, {}, data);

  }

  getAllDataCollections() {

    const path = `${this.basePath}/all`;

    return this.apiClient.get(path, {}, {});

  }

  async getCollectionsByQueryOptions(queryOptions) {

    const path = `${this.basePath}`;

    return this.apiClient.get(path, {}, queryOptions);

  }

  async getPopulatedCollectionById(collectionId) {

    const path = `${this.basePath}/:collectionId`;

    return this.apiClient.get(path, { collectionId }, {});

  }

  async embedCollectionInPage(collectionId, pageId, rowsCount) {

    const path = `${this.basePath}/:collectionId/pages/:pageId`;

    return this.apiClient.post(path, { collectionId, pageId }, {}, { rowsCount });

  }

  async deleteCollection(collectionId) {

    const path = `${this.basePath}/:collectionId`;

    return this.apiClient.delete(path, { collectionId }, {});

  }

  async setupColumn(collectionId, data) {

    const path = `${this.basePath}/:collectionId/columns`;

    return this.apiClient.post(path, { collectionId }, {}, data);

  }

  async updateColumnName(collectionId, columnId, data) {

    const path = `${this.basePath}/:collectionId/columns/:columnId/name`;

    return this.apiClient.put(path, { collectionId, columnId }, {}, data);

  }

  async updateColumnType(collectionId, columnId, data) {

    const path = `${this.basePath}/:collectionId/columns/:columnId/type`;

    return this.apiClient.put(path, { collectionId, columnId }, {}, data);

  }

  async updateColumnPositionById(collectionId, columnId, data) {

    const path = `${this.basePath}/:collectionId/columns/:columnId/position`;

    return this.apiClient.put(path, { collectionId, columnId }, {}, data);

  }

  async deleteColumn(collectionId, columnId) {

    const path = `${this.basePath}/:collectionId/columns/:columnId`;

    return this.apiClient.delete(path, { collectionId, columnId }, {});

  }

  async createRecord(collectionId, data = {}) {

    const path = `${this.basePath}/:collectionId/records`;

    return this.apiClient.post(path, { collectionId }, {}, data);

  }

  async getAllRecordsByQueryOptions(collectionId, queryOptions) {

    const path = `${this.basePath}/:collectionId/records/all`;

    return this.apiClient.get(path, { collectionId }, queryOptions);

  }

  async getRecordsByQueryOptions(collectionId, queryOptions) {

    const path = `${this.basePath}/:collectionId/records`;

    return this.apiClient.get(path, { collectionId }, queryOptions);

  }

  async updateRecordField(collectionId, recordId, columnId, data) {

    const path = `${this.basePath}/:collectionId/records/:recordId/:columnId`;

    return this.apiClient.put(path, { collectionId, recordId, columnId }, {}, data);

  }

  async uploadCollectionFile(collectionId, file) {

    let path = `${this.basePath}/:collectionId`;

    if (isImage(file)) {
      path = `${path}/images`;
    } else if (isVideo(file)) {
      path = `${path}/videos`;
    } else if (isDocument(file)) {
      path = `${path}/documents`;
    }

    const data = new FormData();
    data.append('file', file);

    return this.apiClient.post(path, { collectionId }, {}, data, true, false);

  }

  async deleteRecord(collectionId, recordId) {

    const path = `${this.basePath}/:collectionId/records/:recordId`;

    return this.apiClient.delete(path, { collectionId, recordId }, {});

  }

  exportCollectionAsCSV(collectionId) {

    const path = `${this.basePath}/:collectionId/export/csv`;

    return this.apiClient.downloadFile('GET', path, { collectionId }, {});

  }

  exportCollectionAsXLSX(collectionId) {

    const path = `${this.basePath}/:collectionId/export/xlsx`;

    return this.apiClient.downloadFile('GET', path, { collectionId }, {});

  }

  async uploadFile(file) {

    let path = `${this.basePath}/import-from`;

    const data = new FormData();
    data.append('file', file);

    return this.apiClient.post(path, {}, {}, data, true);

  }

  async getRecordsByFilter(collectionId, filterId, paginationOptions) {

    const path = `${this.basePath}/:collectionId/filters/:filterId/records`;

    return this.apiClient.get(path, { collectionId, filterId }, { paginationOptions });

  }

  async getColumnValuesByQueryOptions(collectionId, columnName, queryOptions) {

    const path = `${this.basePath}/:collectionId/column-values/:columnName`;

    return this.apiClient.get(path, { collectionId, columnName }, queryOptions);

  }

}

export default DataCollections;